
const routes = [
  {
    path: '/',
    component: () => import('layouts/CustomerAuthLayout.vue'),
    children: [
      { path: '', component: () => import('pages/index.vue') }
    ]
  },
  {
    path: '/financial',
    component: () => import('layouts/CustomerAuthLayout.vue'),
    children: [
      { path: '', name: 'financial', component: () => import('pages/financial/conciliation/index.vue') },      
      { path: 'report', name: 'report', component: () => import('pages/financial/report/reports.vue') },
      { path: 'extract/add/:bank', name: 'new_extract', component: () => import('src/pages/financial/extract/create.vue') },
      { path: 'account', name: 'account', component: () => import('pages/financial/account/index.vue') },
      { path: 'account/add', name: 'new_account', component: () => import('pages/financial/account/create.vue') },
      { path: 'account/:id', name: 'view_account', component: () => import('pages/financial/account/view.vue') },
      { path: 'conciliation', name: 'conciliation', component: () => import('pages/financial/conciliation/index.vue') },
      { path: 'conciliation/:bank', name: 'transactions', component: () => import('pages/financial/conciliation/transactions.vue') },
      { path: 'conciliation/:bank/:year/:month', name: 'transactionsDate', component: () => import('pages/financial/conciliation/transactions.vue') },
    ]
  },
  {
    path: '/document',
    component: () => import('layouts/CustomerAuthLayout.vue'),
    children: [
      { path: '', component: () => import('pages/document/index.vue') },
    ]
  },
  {
    path: '/videos',
    component: () => import('layouts/CustomerAuthLayout.vue'),
    children: [
      { path: '', component: () => import('pages/videos/index.vue') },
    ]
  },
  {
    path: '/login',
    component: () => import('layouts/NoAuthLayout.vue'),
    children: [
      { path: '', component: () => import('pages/login.vue') }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
